import React, {useEffect, useState} from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import CustomeHeader from '../../components/Admin/Common/CustomeHeader'
import FilterSelect from '../../components/Admin/Common/FilterSelect'
import SimpleTable from '../../components/Admin/Common/SimpleTable'
import ViewButton from '../../components/Admin/Common/ViewButton'
import KYCView from '../../components/Admin/KYCVerifications/KYCView'
import { get_kycVerification_list } from '../../store/Admin/KYC/KYCVerificationSlice'
// import { get_user_list } from '../store/UserManagement/UserManagementSlice'
import { LeftHead, SubHeadContainer, SubHeadTitle, TablePagination } from '../../StyledComponents/Common'
import {  ContentContainer, TableTitle, TableTop } from '../../StyledComponents/CreateKeyAccountManager'
import { MainContainer } from '../../StyledComponents/Dashboard'
import { IconImg } from '../../StyledComponents/Header'
import { DocText, DocTextContainer, UserIDContainer, UserText } from '../../StyledComponents/KYCVerifications'
import { FilterSection, LabelItem } from '../../StyledComponents/Queries'
import SearchBox from '../../components/Admin/Common/SearchBox'
let debounceTimer= null
function KYCVerifications() {
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams();
    const params_kyc_id = searchParams.get("kyc_id")
    const navigate = useNavigate();
    const [pageType, setPageType] = useState("table");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab] = useState("1");
    const [pageSize, setPageSize] = useState(10);
    const [instance, setInstance] = useState({});
    const [, setQueryInstance] = useState({});
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filter_value, setFilterValue] = useState("All")
    const [, setGetList] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(()=> {
        if(params_kyc_id){
            setGetList(true)
        }
    },[params_kyc_id])
    useEffect(()=>{
        if(pageType === 'table'){
            setQueryInstance({})
            dispatch(get_kycVerification_list(''))
            .then(res=>{
                console.log('login res => ',res.payload.status                );
                if(res?.payload?.status === 200 ){
                    const result =res?.payload?.data?.data
                    console.log(res?.payload?.data?.data,"hiiiiiiiiiiiiiii")
                    setData(result)
                    if(params_kyc_id){
                        let data = result.filter((i)=> String(i.id) === String(params_kyc_id))
                        if(data.length){
                            handleView(data[0])
                        }
                    }
                    setFilterData(res?.payload?.data?.data)
                    // setGetList(false)
                    // setLoading(false)
                }
            })
            .catch(err=>{
                console.error(err);
            })
        }
        // setIsEdit(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[pageType])// pageType,getList

    // React to URL query param changes (e.g. clicking a notification while already
    // on this page). Without this, navigate() only changes the URL and the view
    // never updates until a full page reload.
    useEffect(()=>{
        if(params_kyc_id){
            const record = filterData?.find((i)=> String(i.id) === String(params_kyc_id))
            if(record){
                handleView(record)
            }
        } else {
            setPageType("table")
        }
    },[params_kyc_id, filterData])
     console.log(data)
    const handlePageSizeChange = (current, size) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    const handleView = (record) => {
        setInstance(record)
        setPageType("view_page")
    }

    const handleBack = ()=> {
        setPageType("table")
        navigate(`/kyc-verification`)
    }

    const handleFilterChange = (value) => {
        setFilterValue(value)
        let data = filterData
        if(value !== 'All'){
            data = filterData.filter((i)=> i?.kyc_user?.accept_or_reject === value)
        }
        setData(data)
        setCurrentPage(1)
    }

    const columns = [
        {
            title: 'User ID',
            dataIndex: 'id',
            render: (text, record, index) => {
                return <span>{(index + 1) + ((currentPage - 1) * 10)}</span>;
              },
        
            
        },
        {
            title: 'Full Name',
            dataIndex: 'full_name',
            render: (text,record) => (
                <span>{record.kyc_user?.full_name}</span>
            ),
        },
        {
            title: 'Organization Name',
            dataIndex: 'company_name',
        },
        {
            title: 'Organization Type',
            dataIndex: 'company_type',
            width: '20%',
            render: (text,record) => (
                <span>{record.company_type}</span>
            ),
        },
        {
            title: 'Documents',
            dataIndex: 'document1',
            width: "32%",
            render: (text, record) => (
                <DocTextContainer>
                    {record.documents ? 
                        record.documents?.map((i,index)=> //JSON.PARSE
                            <DocText key={index}>{i.proof}</DocText>
                        )
                    : null}
                </DocTextContainer>
              ),
        },
        {
            title: 'Status',
            dataIndex: 'accept_or_reject',
            render: (text,record) => (
                <StatusText status={record?.kyc_user?.accept_or_reject}>{record?.kyc_user?.accept_or_reject === "Pending_Upload" ? "Upload Pending" : record?.kyc_user?.accept_or_reject === "Processing" ? "Under verification" : record?.kyc_user?.accept_or_reject}</StatusText>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (text, record) => (
                <ViewButton handleClick={handleView} data={record} />
              ),
        },
      ];
      
    // const data = [
    //     {
    //         user_id: "SG234567H",
    //         full_name: "Brad Simmons",
    //         company_name: "Intertico",
    //         company_type: "PVT Ltd",
    //         document1: "Doc1",
    //         document2: "Doc2",
    //         document3: "Doc3",
    //     },
    //     {
    //         user_id: "SG234567H",
    //         full_name: "Brad Simmons",
    //         company_name: "Intertico",
    //         company_type: "PVT Ltd",
    //         document1: "Doc1",
    //         document2: "Doc2",
    //         document3: "Doc3",
    //     },
    // ]
    const filter_options = [
        {
            value: 'All',
            label: 'All',
        },
        {
            value: 'Processing',
            label: 'Processing',
        },
        {
            value: 'Accepted',
            label: 'Accepted',
        },
        {
            value: 'Rejected',
            label: 'Rejected',
        },
    ]
    const onSearch = (value)=>{
            let queryStringObj =  {};
            if(value.length < 1)
                return;
              if (searchTerm?.length > 0) {
                queryStringObj["search"] = value;
              }
            let queryString = new URLSearchParams(queryStringObj).toString();
            queryString = queryString ? `?${queryString}` : "";
            if (debounceTimer) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                dispatch(get_kycVerification_list(queryString))
                .then(res=>{
                    console.log('login res => ',res.payload.status                );
                    if(res?.payload?.status === 200 ){
                        const result =res?.payload?.data?.data
                        console.log(res?.payload?.data?.data,"hiiiiiiiiiiiiiii")
                        setData(result)
                        if(params_kyc_id){
                            let data = result.filter((i)=> String(i.id) === String(params_kyc_id))
                            if(data.length){
                                handleView(data[0])
                            }
                        }
                        setFilterData(res?.payload?.data?.data)
                        // setGetList(false)
                        // setLoading(false)
                    }
                })
                .catch(err=>{
                    console.error(err);
                })
            }, 700);
        }
  return (
    <section className="kycVerificationMain">
    <MainContainer>
      <CustomeHeader title="KYC Verification" description="View all users verification requests and approve." />
      {pageType === 'table'? <>
        <div className="mt-4 tableResponsiveASAP">
            <ContentContainer>
                <TableTop>
                    <TableTitle>KYC Verification Requests</TableTitle>
                    <FilterSection className='filter'>
                        <LabelItem>Filter by</LabelItem>
                        <FilterSelect options={filter_options} width="120px" value={filter_value} handleChange={handleFilterChange} />
                        <SearchBox  onSearch={onSearch} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    </FilterSection>
                
                </TableTop>
                {/* {loading?  */}
                    {/* <SpinContainer className='user-quote'>
                        <Spin />
                    </SpinContainer>:  */}
                    <SimpleTable currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} />
                {/* } */}
            </ContentContainer>
            {data?.length ? 
                <div className="paginationCustom">
                    <TablePagination
                        style={{ marginTop: 16, textAlign: 'center' }}
                        onChange={handlePageChange}
                        onShowSizeChange={handlePageSizeChange}
                        defaultCurrent={currentPage}
                        defaultPageSize={10}
                        total={data?.length? data.length : 10}
                        showSizeChanger={false}
                        showQuickJumper={false}
                    />
                    </div>
            : null}
        </div>
      </>
        :pageType === 'view_page'? 
        <>
        <div className="mt-5">
           <ContentContainer>
                {/* <ContentHead title="User Details"  handleClick={()=> setPageType("table")} /> */}
                
                <SubHeadContainer className='flex-column'>
                    <LeftHead>
                        <IconImg onClick={()=> handleBack()} src={require('../../assets/admin/images/back_page_arrow.png')} />
                        <SubHeadTitle>KYC Verification Requests</SubHeadTitle>
                    </LeftHead>
                   <UserIDContainer>
                    <UserText>USER ID</UserText>
                    <UserText className='value'>{instance?.kyc_user?.id}</UserText>
                   </UserIDContainer>
                </SubHeadContainer>
                <KYCView instance={instance} setQueryInstance={setQueryInstance} setPageType={setPageType} tab={currentTab} />
            </ContentContainer>
        </div>
        </>
       
        
        : null}
      
      
    </MainContainer>
    </section>
  )
}

export default KYCVerifications

const StatusText = styled.span`color: ${({status})=> status === 'Accepted' ? '#08C004': status === 'Rejected'? '#FF3F3B' :status === 'Processing'? '#FCBD2C' :status === 'Pending_Upload'? '#ed7437':'#3F4254' };font-weight: 700;`